import { render, staticRenderFns } from "./DealerDirections.vue?vue&type=template&id=f787bf3e&scoped=true"
import script from "./DealerDirections.vue?vue&type=script&lang=js"
export * from "./DealerDirections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f787bf3e",
  null
  
)

export default component.exports